import React from "react";

export const SelectedIcon = React.memo(({color = "var(--messenger-blue-dark)"}: any) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8.51011L6.40414 11.808L13 4.99996" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});